//JavaScript Document
import axios from "axios";
const unicorEyeAppId = "MB-ISPQLY-0000";
import storage from "@dss/js/helper/storage";
export const {
  unicorEyeAppKey,
} = ENV_CONFIG;
let cryptoSHA256 = require("crypto-js/sha256"),
  encHex = require("crypto-js/enc-hex");

let getSign = (timestamp, body = "", url, appId, appKey) => {
  body = body.replace(/\s/g, "");
  body = body.replace(/\t/g, "");
  body = body.replace(/\r/g, "");
  body = body.replace(/\n/g, "");

  url = url.substring(url.indexOf("/", 8));
  if (url.indexOf("?") != -1) {
    url = url.substring(0, url.indexOf("?"));
  }
  let sign = encHex.stringify(
    cryptoSHA256(url + body + appId + appKey + timestamp)
  );
  return sign;
};
// axios.defaults.headers.common["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8";
// axios.defaults.headers.common["Access-User-Token"] = window.localStorage.getItem("Access-User-Token") || "";

// 发送请求前处理request的数据
/* axios.defaults.transformRequest = [function (data, headers) {
  let formData = '';
  for (let key in data) {
    formData += key + '=' + data[key] + '&';
  }
  return formData.substring(0, formData.length - 1);
}]; */

// 带cookie请求
// axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  (config) => {
    if (config.headers && config.url.indexOf('/user/getUserList') > 0) {
      const timestamp = new Date().getTime().toString();
      config.headers.appId = unicorEyeAppId;
      config.headers.timestamp = timestamp;
      config.headers.sign = getSign(timestamp, JSON.stringify(config.data), config.url, unicorEyeAppId, unicorEyeAppKey);
      config.headers["Access-User-Token"] = storage.get("access-user-token", "cookie");
		}
    return config
	},
	err => {
		return Promise.reject(err)
	}
)
axios.interceptors.response.use(
  (response) => {
    //=>设置响应拦截器，在AJAX请求成功，执行对应方法之前，把从服务器获取的RESULT(包含了响应主体和响应头等很多信息)中的DATA获取到然后返回，这样在请求成功执行的函数中，再次遇到的RESULT只有响应主体内容
    return response.data;
  },
  (error) => {
    // console.log(error,error.response)

    if (error.response && error.response.status == 401) {
       // TODO:临时注销，方便调试登录成功后的效果(部署时候需放开下面三行)
      localStorage.clear();
      window.location.hash = "#/login";
      throw new Error("您尚未登录，请先登录!");      
    }
    if (error.response && error.response.status == 400) {
      if (error.response.data.message.indexOf("已经登录") > -1) {
        window.location.hash = "#/";
      } else {
        throw new Error(error.response.data.message);
      }
    }
    return {
      status: error.response ? error.response.status : "",
      data: error.response ? error.response.data : ""
    };
  }
);

export default axios;
